/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import React from "react";
import { withFocusability, withCaretOnFocus } from "containers/accessibility/AccessibleFocusableNodeContainers";
import { AccessibleLinkNode, PlainLinkNode } from "components/accessibility/AccessibleLinkNode";
import { simulateClick } from "utils/AccessibilityUtils";
import { useContext } from "react";
import { FormattedCopyContext } from "utils/CopyTextUtils";

const mapStoresToProps = (stores, ownProps) => ({
  onClick: evt => simulateClick(evt, ownProps.pageIndex, stores)
});

const AccessibleFocusableLinkNodeContainer = withCaretOnFocus(
  withFocusability(inject(mapStoresToProps)(AccessibleLinkNode))
);

const AccessibleLinkNodeContainer = props => {
  const formattedCopyContext = useContext(FormattedCopyContext);
  return formattedCopyContext ? <PlainLinkNode {...props} /> : <AccessibleFocusableLinkNodeContainer {...props} />;
};

export { AccessibleLinkNodeContainer };
